import { type FinalReservationType } from 'types/Reservation';
import { get, post } from 'lib/httpClient';
import { fetchWithCache, clearApiCache } from 'lib/apiCache';

const post_reservation = async (
  reservation: FinalReservationType,
  callback: ((data: any) => void) | null = null
): Promise<void> => {
  const path = `/reservation/register`;
  const result = await post(path, reservation);
  clearApiCache();
  console.debug('post_reservation', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

const cancel_reservaton = async (
  reservationId: string,
  callback: ((data: any) => void) | null = null
): Promise<void> => {
  const path = `/reservation/cancel`;
  const param = {
    reservation_id: reservationId,
  };
  const result = await post(path, param);
  clearApiCache();
  console.debug('cancel_reservaton', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

const retrieve_reservation = async (
  reservationId: string,
  callback: ((data: any) => void) | null = null,
  options: { forceRefresh?: boolean } = {}
): Promise<void> => {
  const { forceRefresh = false } = options;
  const path = '/reservation/retrieve?reservation_id=' + reservationId;
  const result = await fetchWithCache(path, () => get(path), forceRefresh);
  console.debug('retrieve_reservation', result?.data);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { post_reservation, cancel_reservaton, retrieve_reservation };
